require('./brokerInternalTransferFundsStep2.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { BrokerFundLegalDocumentDisclaimer } = require('components/broker/brokerFundLegalDocumentDisclaimer/brokerFundLegalDocumentDisclaimer');
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';
const { OKMessage } = require('commonsComponents/OKMessage');
const BrokerInternalTransferFundsStep2ExantDetails = require('components/broker/brokerInternalTransferFundsStep2ExantDetails/brokerInternalTransferFundsStep2ExantDetails');
const { MULTIPLE_OPERATIONS } = require('constants/operationTypes');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const { getPersonTypeAndCode } = require('utilities/hash');
// @constants
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    FIRST_STEP,
    SECOND_STEP,
    BROKER_PRODUCT_TYPE_FUNDS,
    API_CHANNEL,
    BROKER_INTERNAL_TRANSFER_EXISTING_FUND,
} = require('constants/index');
const {
    BROKER_INTERNAL_TRANSFER_FUND_ID,
    INTERNAL_TRANSFER_FUNDS_CONTRIBUTION_WITH_FUND_IN_WALLET,
    INTERNAL_TRANSFER_FUNDS_CONTRIBUTION_WITHOUT_FUND_IN_WALLET,
} = require('constants/operationTypes');

// @utilities
import { recordPage, recordLinkV2 } from "utilities/tagging";
const {
    brokerTransferFundsTags,
    buildAmount
} = require('../../../../utilities/taggingInfo/brokerTransferFundsTags');
class BrokerInternalTransferFundsStep2 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            allowClickDisclaimer: false,
            showDisclaimerErrorState: false
        }
        this.buildDisclaimer = this.buildDisclaimer.bind(this);
        this.getAmount = this.getAmount.bind(this);
    }

    componentWillMount() {
        this.props.getPreMotor(this.props.history);
        this.props.getInterveners();
        this.props.validateEconomicReport(this.props.history);
    }

    componentDidMount() {
        const { immBrokerInternalTransferFunds } = this.props;
        const partialType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'partialType']);
        const originFundCurrency = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFundCurrency']);
        recordPage({
            ...buildAmount(partialType, this.getAmount(partialType), originFundCurrency)
        });
    }

    componentDidUpdate() {
        const { immSignaturePattern, immBrokerInternalTransferFunds } = this.props;
        const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);
        const partialType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'partialType']);
        const originFundCurrency = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFundCurrency']);
        const amount = this.getAmount(partialType)

        if (immSignaturePattern.get('showWarningSMS')) {
            recordLinkV2({
                ...brokerTransferFundsTags(fundType, partialType, amount, originFundCurrency)
            })
        }
    }

    getAmount(partialType) {
        const { immBrokerInternalTransferFunds } = this.props;

        const amounts = {
            'percentage': immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'percentage']),
            'participations': immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'participations']),
            'amount': immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'amount']),
        }

        return amounts[partialType];
    }

    handleDisclaimerChecked = () => {
        const { onDisclaimerChecked } = this.props
        const { allowClickDisclaimer } = this.state
        if(allowClickDisclaimer) {
            this.setState({ showDisclaimerErrorState: false })
            onDisclaimerChecked()
        }else {
            this.setState({ showDisclaimerErrorState: true })
        }
    }

    buildDisclaimer() {
        const { immInvestmentFunds, immBrokerInternalTransferFunds, immFlagBasedFeatures } = this.props;
        const { showDisclaimerErrorState } = this.state

        const fundName = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'name']);
        const fundIsin = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);
        const fundSecId = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'secId']);
        const originFundIsin = immBrokerInternalTransferFunds.get('isinFondoOrigen');
        const originHasContribution = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originHasContribution']);
        const destinationHasContribution = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'destinationHasContribution']);
        const onlyOriginContribution = originHasContribution && !destinationHasContribution;
        const immSteps = immBrokerInternalTransferFunds.get('steps');
        const isTotalTransfer = immSteps.getIn([FIRST_STEP, 'type']) === 'total';

        const showDetailsCost = immFlagBasedFeatures.get('wealth_funds_transfer_show_costs');
        const fetchingDocumentValitdation = immBrokerInternalTransferFunds.get('fetchingDocumentsValidate')

        if (fundName && fundIsin && fundSecId && originFundIsin && !fetchingDocumentValitdation) {
            const isSpanish = (fundIsin + '').slice(0, 2).toLowerCase() === 'es';
            const indexStep = onlyOriginContribution && isTotalTransfer ? 2 : SECOND_STEP
            const disclaimerChecked = immBrokerInternalTransferFunds.getIn(['steps', indexStep, 'disclaimerChecked']);
            const disclaimerError = immBrokerInternalTransferFunds.getIn(['steps', indexStep, 'disclaimerInvalid']);
            const disclaimerErrorMessage = formatText('brokerInternalTransferFund-disclaimerError');

            const enableEconomicReport = immBrokerInternalTransferFunds.get('enableEconomicReport');
            return (
                <div>
                    <BrokerLegalDocumentation
                        className="hire-investment-step2__documentation-box"
                        isin={fundIsin}
                        secId={fundSecId}
                        productDefinition={fundName}
                        productType={BROKER_PRODUCT_TYPE_FUNDS}
                        reportCompleted={() => this.setState({ allowClickDisclaimer: true })}
                        enableTransactionCost={!showDetailsCost}
                        enableEconomicReport={enableEconomicReport}
                    />
                    { originHasContribution && isTotalTransfer &&
                        <div className="broker-internal-transfer-funds-step2__contributions-disclaimer">
                            <FormattedText value="brokerInternalTransferFund-disclaimerCancelPrevContibution" />
                        </div>
                    }
                    {showDisclaimerErrorState &&
                        <OKMessage type="warning">
                            <FormattedText value="brokerLegalDocumentation-documentsRead" />
                        </OKMessage>
                    }
                    <BrokerFundLegalDocumentDisclaimer
                        disclaimerErrorState={disclaimerError}
                        disclaimerErrorMessage={disclaimerErrorMessage}
                        disclaimerChecked={disclaimerChecked}
                        onDisclaimerCheckChange={() => this.handleDisclaimerChecked()}
                        isSpanish={isSpanish}
                        fundName={fundName}
                        fundIsin={fundIsin}
                        fundSecId={fundSecId}
                        isInternalTransferFund={true}
                        internalTransferOriginFundIsin={originFundIsin}
                        enableTransactionCost={!showDetailsCost}
                    />

                </div>
            );
        } else {
            return <LoadingSection/>;
        }
    }

    render() {
        const {
            immBrokerInternalTransferFunds,
            immBrokerMyInvestments,
            immFlagBasedFeatures,
            immAccounts,
            immFunds
        } = this.props;
        const partialType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'partialType']);
        const originFundCurrency = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFundCurrency']);
        const amount = buildAmount(partialType, this.getAmount(partialType), originFundCurrency);
        const originFund = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFund']);
        const funds = immBrokerMyInvestments.getIn(['products','funds','stocks']);
        const selectedOrigin = funds.find(fund => fund.get('id') === originFund);
        const fundLegalDocumentDisclaimer = this.buildDisclaimer();
        const originHasContribution = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originHasContribution']);
        const destinationHasContribution = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'destinationHasContribution']);
        const onlyOriginContribution = originHasContribution && !destinationHasContribution;
        const immSteps = immBrokerInternalTransferFunds.get('steps');
        const isTotalTransfer = immSteps.getIn([FIRST_STEP, 'type']) === 'total';
        const indexStep = onlyOriginContribution && isTotalTransfer ? 2 : SECOND_STEP
        const disclaimerChecked = immBrokerInternalTransferFunds.getIn(['steps', indexStep, 'disclaimerChecked']);
        const showDetailsCost = immFlagBasedFeatures.get('wealth_funds_transfer_show_costs');
        const destinationFundId  = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'destinationFund']);    
        const selectedDestinationFund = funds.find(x => x.get('id') === destinationFundId);
        
        const costDetails = showDetailsCost ? (
            <BrokerInternalTransferFundsStep2ExantDetails
                immAccounts={immAccounts}
                immBrokerInternalTransferFunds={
                    immBrokerInternalTransferFunds
                }
                immBrokerMyInvestments={immBrokerMyInvestments}
                immFunds={immFunds}
            />
        ) : null;

        let operationParams = {
            originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${selectedOrigin.get('product')}${selectedOrigin.get('numerodecontrato')}`
        };

        let operationType = BROKER_INTERNAL_TRANSFER_FUND_ID;

        const userData = getPersonTypeAndCode();
        const idUser = userData.f;
        const documentTypeUser = userData.type;
        const isContributionStepSkipped = immBrokerInternalTransferFunds.get('skipContributionStep')

        if (onlyOriginContribution && !isContributionStepSkipped && isTotalTransfer) {
            const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);
            const existFundsInWallet = fundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND;
            operationType = MULTIPLE_OPERATIONS;
            operationParams = {
                requestMulti: [
                    {
                        serviceCode: BROKER_INTERNAL_TRANSFER_FUND_ID,
                        originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${selectedOrigin.get('product')}${selectedOrigin.get('numerodecontrato')}`
                    },
                    {
                        serviceCode: existFundsInWallet
                            ? INTERNAL_TRANSFER_FUNDS_CONTRIBUTION_WITH_FUND_IN_WALLET
                            : INTERNAL_TRANSFER_FUNDS_CONTRIBUTION_WITHOUT_FUND_IN_WALLET,
                        ammount: `+${immBrokerInternalTransferFunds.getIn(['steps', 1, 'amount'])}`,
                        channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
                        clientId: `${idUser}`,
                        clientType: documentTypeUser,
                        currency: immBrokerInternalTransferFunds.getIn(['steps', 1, 'customMinimumPurchaseAmount', 'currency']),
                    },
                ]
            };
        }

        return (
            <div className="broker-internal-transfer-funds-step2">
                <FormattedText value="brokerInternalTransferFund-confirmationTitle" className="broker-internal-transfer-funds-step2__title"/>
                <FormattedText value="brokerInternalTransferFund-confirmationSubtitle" className="broker-internal-transfer-funds-step2__description"/>
                <div className="broker-internal-transfer-funds-step2__cost-details">
                    {costDetails}
                </div>
                {fundLegalDocumentDisclaimer}
                {disclaimerChecked &&
                    <div>
                        <SignaturePattern
                            operationType={operationType}
                            operationParams={operationParams}
                            taggingDataLink={amount}
                        />
                    </div>
                }
            </div>
        );
    }
}

BrokerInternalTransferFundsStep2.propTypes = {
    history: PropTypes.object.isRequired,
    immInvestmentFunds: PropTypes.object.isRequired,
    immBrokerInternalTransferFunds: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    getPreMotor: PropTypes.func.isRequired,
    getMorningStarScreener: PropTypes.func.isRequired,
    onDisclaimerChecked: PropTypes.func.isRequired,
    getInterveners: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFunds: PropTypes.object.isRequired,
    validateDestinationFundDocuments: PropTypes.object.isRequired,
    validateEconomicReport: PropTypes.object.isRequired,
};

module.exports = withRouter(BrokerInternalTransferFundsStep2);
